import { post } from '@/utils/http'

/**
 * Return the URL used for WeChat JS-SDK signature validation.
 * Hash routes are client-side only and must not be part of the signed URL.
 */
export function normalizeWechatSignUrl(url) {
    const value = String(url || '')
    const hashIndex = value.indexOf('#')
    return hashIndex === -1 ? value : value.slice(0, hashIndex)
}
//免登录获取单条溜溜壶详情(H5用)
export const info = function (data) {
    return post({
        url: "/app/user/circle/info",
        data
    })
}

//微信跳转APP所需参数
export const shareConfig = function (data) {
  const requestData = {
    ...(data || {}),
    url: normalizeWechatSignUrl((data && data.url) || window.location.href)
  }
  return post({
      url: "/app/user/wx/shareConfig",
      data: requestData
  })
}

//h5内再分享所需参数
export const shareMsg = function (data) {
    return post({
        url: "/app/user/circle/share",
        data
    })
  }
